import { defineComponent as _defineComponent } from 'vue'
import UpcomingMeeting from "../components/upcomingMeeting.vue";
import { useRouter } from 'vue-router';
import { computed, ref, watch } from 'vue';
import { ISOTimestamp } from "@busy-human/gearbox";
import { PersonName } from "@busy-human/gearbox";
import { Userspaces, FinancialUserspaces, FunctionTypes, Transactions, DataInstance } from "@busy-human/opt-library";
import { auth, functions } from '@/util/firebase';
import { getLink } from "./partials/setup-payment";
import VLoader from "../components/loader.vue"
import { httpsCallable } from 'firebase/functions';
import { useBalance } from "@/util/balance";
import { useUserspace } from "@/store/userspace";
import { useTransactions } from "@/store/transactions";

type namecache = {
    [uid: string]: PersonName
}


export default /*#__PURE__*/_defineComponent({
  __name: 'balance',
  setup(__props, { expose }) {
  expose();

const env = ref(ENVIRONMENT)

const hideTransfers = ref((ENVIRONMENT !== "dev" && ENVIRONMENT !== "development"));

const router = useRouter();
const loading = ref(false);
const userspace = useUserspace();
const currentUser = computed(() => userspace.user);
// console.log("current user", currentUser)
const goTo = (route: string) => {
    router.push(route)
}

const balances = useBalance();

const tmpNextMeeting = {
    meetingDate: new Date(1649952900000),
    recipient: "Dana Carvey",
    duration: 30,
    cost: 50,
    paid: false
}

const interpretTime = (date: ISOTimestamp) => {
    const tmp = new Date(date);
    const dateOptions: Intl.DateTimeFormatOptions = { month: 'short', day: "numeric" }
    return new Intl.DateTimeFormat('en-US', dateOptions).format(tmp);
}

const personNameCache = ref<namecache>({});

const getOtherForTransaction = (transaction: Transactions.Model) => {
    if(transaction.source.scope === userspace.uid) {
        return transaction.target.scope || 'unknown';
    } else {
        return transaction.source.scope || 'unknown';
    }
}

const transactions = computed(() => {
    let transactions = useTransactions().list;

    let filtered = transactions.sort((a: Transactions.Model, b: Transactions.Model) => {
        if (a.createdAt < b.createdAt) return 1
        else if (a.createdAt == b.createdAt) return 0
        else return -1
    })

    return filtered;
});

const filteredTransactions = computed(() => {
    let transactions = useTransactions().list;

    let filtered = transactions.filter((transaction) => 
        !Transactions.isTransfer(transaction) && 
        transaction.target?.scope === currentUser.value.$id && 
        !(transaction.status == 'credited' && transaction.target.scope===currentUser.value.$id))

    filtered = filtered.sort((a: Transactions.Model, b: Transactions.Model) => {
        if (a.createdAt < b.createdAt) return 1
        else if (a.createdAt == b.createdAt) return 0
        else return -1
    })

    return filtered;
});

const resolveTransactionName = (transaction: Transactions.Model) => {
    switch(transaction.type){
        case Transactions.TransactionType.payment: 
            return personNameCache.value[getOtherForTransaction(transaction)]?.fullName || "Unknown"
        case Transactions.TransactionType.fee: 
            return "Opt Scheduling Fee"
        case Transactions.TransactionType.deposit: 
            return "Deposit"
        case Transactions.TransactionType.payout: 
            return "Payout";
        case Transactions.TransactionType.feeTransfer: 
            return "Fee Transfer";
        case Transactions.TransactionType.earningsTransfer: 
            return "Earnings Transfer   ";
        case Transactions.TransactionType.excessFeeReturnTransfer: 
            return "Fee Reversal";
        case Transactions.TransactionType.credit: 
            return "Credit";
        case Transactions.TransactionType.refund: 
            return "Refund";
        case Transactions.TransactionType.adjustment: 
            return "Adjustment";
        default:
            return ""
    }
}


//Theres only 1 difference so far but this might change in the future
const payerTransactionStatusMap = {
    draft: "pending",
    authorized: "pending",
    hold: "pending",
    pending: "pending",

    posted: "pending",
    available: "pending",

    complete: "",

    canceled: "canceled",
    failed: "failed",

    credited: "credited"
}

const collectorTransactionStatusMap = {
    draft: "pending",
    authorized: "pending",
    hold: "pending",
    pending: "pending",
    
    posted: "pending",
    available: "pending",

    complete: "available",

    canceled: "canceled",
    failed: "failed",

    credited: "credited"
}


watch(() => transactions.value, async val => {
    // console.log(val);
    await Promise.all(val.map(async transaction => {
        if(transaction.source.scopeType === Transactions.TransactionTargetScopeType.optUserId
            && transaction.source.scope && transaction.source.scope !== userspace.uid) {
                personNameCache.value[transaction.source.scope] = (await Userspaces.Collection.fetchData(transaction.source.scope)).name
            }
        if(transaction.target.scopeType === Transactions.TransactionTargetScopeType.optUserId
            && transaction.target.scope && transaction.target.scope !== userspace.uid) {
                personNameCache.value[transaction.target.scope] = (await Userspaces.Collection.fetchData(transaction.target.scope)).name
            }
    }))
    // console.log(personNameCache.value);
}, { immediate: true })

const moveToWithdraw = () => {
    router.push({ name: 'withdraw-balance', params: { 'withdrawParams': '#' } })
}


const __returned__ = { env, hideTransfers, router, loading, userspace, currentUser, goTo, balances, tmpNextMeeting, interpretTime, personNameCache, getOtherForTransaction, transactions, filteredTransactions, resolveTransactionName, payerTransactionStatusMap, collectorTransactionStatusMap, moveToWithdraw, UpcomingMeeting, useRouter, computed, ref, watch, ISOTimestamp, PersonName, Userspaces, FinancialUserspaces, FunctionTypes, Transactions, DataInstance, auth, functions, getLink, VLoader, httpsCallable, useBalance, useUserspace, useTransactions }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})